import React, { useState } from "react";
import styles from './partList.module.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button, Grid,

} from "@mui/material";
import { Close, Payment, Refresh } from "../../../Svg";
import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { styled } from '@mui/material/styles';


const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));



const EditWizardEnquires = () => {
  const data = [
    { id: 1, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 2, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 3, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 4, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 5, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 6, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 7, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 8, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 9, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 10, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 11, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 12, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 13, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 14, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 15, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 16, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 17, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 18, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 19, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    { id: 20, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
  ];
  // Handle page navigation
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate total number of pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get the current items to display
  const currentItems = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  // Generate an array for page numbers
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <>
      <NestedUserHeader
        index="Edit Enquiry"
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />


      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              10 Products
            </Typography>
            <Typography style={{ margin: '6px'}}>•</Typography>
            <Typography style={{  padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Quoted date: 24 Sep 2024
            </Typography>
            <Typography style={{ margin: '6px'}}>•</Typography>
            <Typography style={{  padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#006C64' }}>
              Quoted
            </Typography>
            <Typography style={{  padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: '#E9BD21' }}>
              Pending
            </Typography>
          </Box>
         {/*  <Box display="flex" alignItems="center" >
            <ActionButton> Edit Quote</ActionButton>
          </Box> */}
        </Box>

        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture Part #</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Required Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>Price</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>MOQ</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '3%' }}>{item.id}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.partNumber}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>{item.quantity}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '5%' }}>

                    {item.manufacturer}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '8%' }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter"
                      className={styles.addCatInput}
                    />
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>
                    <div className={styles.closetd}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter"
                        className={styles.addCatInput}
                      />
                      <div style={{ display: "flex", gap: "20px", padding: '0px 20px' }}>
                        <Refresh /> <Close />
                      </div>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>


          <div className={styles.displayFlex}>
            <button className={styles.cancelBtn}>Cancel</button>
            <button className={styles.submitBtn}>Approve & submit</button>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default EditWizardEnquires;
